import React, { useState, useEffect } from 'react';
import DashboardHeader from '../components/navigation/shared/DashboardHeader';
import AdminSidebar from '../components/navigation/AdminSidebar';

interface AdminLayoutProps {
  children: React.ReactNode;
  companyName: string;
  email: string;
  logoUrl?: string;
  onLogout: () => void;
  onGotoProfile: () => void

}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  companyName,
  email,
  logoUrl,
  onGotoProfile,
  onLogout
}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsSidebarOpen(false); // Fermer la sidebar quand on passe en desktop
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleToggleSidebar = () => {
    if (isMobile) {
      setIsSidebarOpen(!isSidebarOpen);
    } else {
      setIsSidebarCollapsed(!isSidebarCollapsed);
    }
  };

  const closeMobileSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="flex h-screen bg-gray-50/50 overflow-hidden">
      {/* Sidebar pour desktop */}
      {!isMobile && (
        <div className="flex-shrink-0">
          <AdminSidebar
            isCollapsed={isSidebarCollapsed}
            onToggle={handleToggleSidebar}
            username={companyName}
            logoUrl={logoUrl}
          />
        </div>
      )}

      {/* Sidebar pour mobile */}
      {isMobile && (
        <>
          {/* Overlay */}
          {isSidebarOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-200"
              onClick={closeMobileSidebar}
            />
          )}

          {/* Sidebar mobile */}
          <div className={`
            fixed inset-y-0 left-0 z-50 transform transition-transform duration-200 ease-in-out
            ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          `}>
            <AdminSidebar
              isCollapsed={false}
              onToggle={closeMobileSidebar}
              username={companyName}
              logoUrl={logoUrl}
              isMobile={true}
            />
          </div>
        </>
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        <div className="flex-shrink-0">
          <DashboardHeader
            onGotoProfile={onGotoProfile}
            onLogout={onLogout}
            onToggleSidebar={handleToggleSidebar}
            isSidebarCollapsed={isSidebarCollapsed}
            username={companyName}
            email={email}
            logoUrl={logoUrl}
          />
        </div>

        <main className="flex-1 overflow-auto">
          <div className="max-w-7xl mx-auto p-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;